module.exports = __webpack_public_path__ + "static/media/gradient_blue.19950386.PNG";